export default {
  VENTURE_PITCH: "venturePitch",
  FINANCIAL_PLAN: "financialPlan",
  SEVEN_FOUNDERS_FORECAST: "sevenFoundersForecast",
  DATA_REQUEST: "dataRequest",
};
